<template >
    <div class="public-offer-points">
        <default-description :size="16" :line-height="21">
            {{ t("payments.bonuses") }}
            <b>
                {{
                    order.is_using_points
                        ? order.available_points - order.available_withdrawal_points
                        : order.available_points
                }}
                {{ order.price_info.price.currency.code }}
            </b>
            <span style="font-size: 13px">
                ({{ order.available_points_without_course }} {{ t("course.points") }})
            </span>
        </default-description>

        <div class="mt-6">
            <default-description>
                {{ t(order.is_using_points ? "payments.debited" : "payments.available_withdrawal") }}
                <b> {{ order.available_withdrawal_points }} {{ order.price_info.price.currency.code }} </b>
                <a
                    @click="
                        $set(order, 'is_using_points', !order.is_using_points)
                        $emit('update:order')
                    "
                    class="ml-5 orange"
                    href="#"
                >
                    {{ t(order.is_using_points ? "order.cancel" : "payments.withdraw") }}
                </a>
            </default-description>

            <default-description class="mt-5" v-if="order.max_withdrawal_points_amount && !order.is_using_points">
                ({{ t("payments.max_withdrawn_amount") }} {{ order.max_withdrawal_points_amount }}
                {{ order.price_info.price.currency.code }})
            </default-description>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import DefaultDescription from "@components/Typography/DefaultDescription.vue"

export default {
    components: { DefaultDescription },
    props: {
        order: {
            type: Object,
            default: () => {}
        }
    },
    name: "PublicOfferPoints",
    computed: {
        ...mapGetters({
            user: "user/currentUser"
        })
    }
}
</script>



<style scoped lang="sass">

</style>
